export const formatDictAsHtml = (dict?: Record<string, string>) => {
  if (!dict) {
    return ''
  }

  return Object.entries(dict)
    .map(([question, answer]) => {
      if (question === '__typename') {
        return ''
      }
      return `<b>${question}</b>: ${answer}`
    })
    .join('<br/><br/>')
}
